export default {
  async created() {
    if (this.$store.state.all == undefined || !this.$store.state.all.length) {
      //removed cart
      await this.$store.dispatch("getAllData");
    }
  }
}
